import { defineComponent as _defineComponent } from 'vue';
import StoreLocaleFlagIcon from '@/components/Layout/StoreLocaleSelector/StoreLocaleFlagIcon.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import useShippingCountry from '~/composables/useShippingCountry';
import { getCountryLabelByCode } from '~/utils/localization';

// TODO: Should use classic destructuring when upgrading to min version 3.13.1 of Nuxt (vue 3.5 allows it)
// https://vuejs.org/guide/typescript/composition-api#props-default-values
// https://github.com/nuxt/nuxt/releases/tag/v3.13.1

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreLocaleSelector',
  props: {
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var _ref = __props,
      iconOnly = _ref.iconOnly;

    // components

    var _useUiState = useUiState(),
      toggleLanguageModal = _useUiState.toggleLanguageModal;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country;
    var currentLocaleLabel = computed(function () {
      return locale.toUpperCase();
    });
    var currentCountryLabel = computed(function () {
      return getCountryLabelByCode(currentCountry.value);
    });
    return {
      __sfc: true,
      iconOnly: iconOnly,
      toggleLanguageModal: toggleLanguageModal,
      locale: locale,
      currentCountry: currentCountry,
      currentLocaleLabel: currentLocaleLabel,
      currentCountryLabel: currentCountryLabel,
      StoreLocaleFlagIcon: StoreLocaleFlagIcon
    };
  }
});